import React from 'react';
// import { CircularProgressbar } from 'react-circular-progressbar';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ownerAvatar from '../../assets/images/icons/owner-icon.png';
import signature from '../../assets/images/icons/sign.png';
import Cta from '../Cta';

function Numbers() {
  return (
    <section className="numbers-wrapper section-padding">
      <div className="container">
        <Cta />
        <div className="row">
          <div className="col-lg-5">
            <div className="left-content">
              <div className="section-head">
                <span className="heading-bg">Numbers</span>
                <h2 className="section-title mb-20">
                  Our services and the right solutions
                  <span className="heading-dot" />
                </h2>
              </div>
              <h4 className="small-heading">
                It is always convenient to receive a service from reliable
                source. We offer a full cycle of house.
              </h4>
              <p className="body-text">
                When building houses for our Customers, we use only modern
                building materials, the quality of which is confirmed by
                appropriate certificates and certificates, and all work is
                carried out on the basis of strict observance of building codes
                and regulations existing today in the country.
              </p>
            </div>
            <div className="numbers-profile d-flex align-items-center flex-wrap">
              <div
                className="profile-img bg-cover"
                style={{ backgroundImage: `url(${ownerAvatar})` }}
              />
              <div className="profile-info">
                <h4 className="name">Alexander Thompson</h4>
                <span className="role">Owner of company</span>
              </div>
              <div className="signature align-self-end">
                <img src={signature} alt="sign" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 d-flex align-items-center justify-content-center">
            <div className="right-content">
              <div className="progressbar-wrapper">
                <div className="circular-progress circle-1">
                  <CircularProgressbarWithChildren
                    value={75}
                    text={`${75}%`}
                    strokeWidth={5}
                  >
                    <h4 className="progress-text">Starting Project</h4>
                  </CircularProgressbarWithChildren>
                </div>

                <div className="circular-progress circle-2">
                  <CircularProgressbarWithChildren
                    value={36}
                    text={`${36}%`}
                    strokeWidth={5}
                  >
                    <h4 className="progress-text small">Annual awards</h4>
                  </CircularProgressbarWithChildren>
                </div>

                <div className="circular-progress circle-3">
                  <CircularProgressbarWithChildren
                    value={95}
                    text={`${95}%`}
                    strokeWidth={5}
                  >
                    <h4 className="progress-text ">Happy clients</h4>
                  </CircularProgressbarWithChildren>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Numbers;
